import * as RouteDefinition from '../Data/RouteDefinition'

export type M =
    | Root
    | Login
    | PasswordLost

interface Root {
    readonly type: 'Root'
}

interface Login {
    readonly type: 'Login'
}

interface PasswordLost {
    readonly type: 'PasswordLost'
}

export const definitions: RouteDefinition.M<M>[] = [
    {
        pattern: /^$/,
        constructor: () => ({type: 'Root'}),
    },
    {
        pattern: /^\/login$/,
        constructor: () => ({type: 'Login'}),
    },
    {
        pattern: /^\/password-lost$/,
        constructor: () => ({type: 'PasswordLost'}),
    },
]

export function url(route: M): string {
    switch (route.type) {
        case 'Root':
            return ''
        case 'Login':
            return '#/login'
        case 'PasswordLost':
            return '#/password-lost'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App/PublicRoute.ts